import { defineNuxtPlugin } from '@nuxtjs/composition-api'
import { useUserStore } from '~/store/user'

export default defineNuxtPlugin((context) => {
  const userStore = useUserStore()

  if (userStore.user?.inLoyaltyProgram && userStore.user.loyaltyLevel.name)
    context.$emitter.emit('page-open', { level_name: userStore.user.loyaltyLevel.name })
})
